export default "__VITE_ASSET__DpLo_Fvl__"